import React, { Component } from 'react';
import { Badge, Button, ButtonToolbar, Card, Col, Modal, Container, Form, Row, Table } from 'react-bootstrap';
import authService from '../api-authorization/AuthorizeService';
import { Link } from 'react-router-dom';
import { numberformat, dateMDY } from '../../DateHelper';
import Moment from 'react-moment';
import OrderDetail from '../DataTable/OrderDetail';
class InvoiceDetailSalvageSalesTruck extends Component {

    constructor(props) {
        super(props);
        this.handleClose = this.handleClose.bind(this);
        this.state = {
            InvoiceList: [], InvoiceListTruck:[], Data: {}, thd: {}, show: false, loading: true
        };
    }
    handleClose() {
        this.setState({ show: false });
    }
    handleShow(orderNumber) {
        //let order = orderNumber.split(':');
        this.setState({
            orderNumber: orderNumber
        });
        this.setState({ show: true });
    }
    print() {
        var content = document.getElementById('printarea');
        var pri = document.getElementById('ifmcontentstoprint').contentWindow;
        pri.document.open();
        pri.document.write(content.innerHTML);
        pri.document.close();
        pri.focus();
        pri.print();
    }
    //componentDidMount() {
    //    this.SalvageInvoiceDetailsById(this.props.invoiceId);
    //}

    //async SalvageInvoiceDetailsById(invoiceId) {
    //     const token = await authService.getAccessToken();
    //    const response = await fetch('InvoiceCode/Invoice?id=' + invoiceId, {
    //        headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    //    });
    //    const data = await response.json();
    //    this.setState({ thd: data, loading: false });
    //    this.setState({ customerDetail: data.invoiceCustomer, loading: false });
    //    this.setState({ InvoiceDetailsById: data.berOrTurboManualInvoiceItemList, loading: false });
    //}


    render() {
        var txt;
        if (this.props.InvoiceCust.paymentOption == 0) {
            txt = 'NotSpecified'
        }
        else if (this.props.InvoiceCust.paymentOption == 1) {
            txt = 'Prepaid'
        }
        else if (this.props.InvoiceCust.paymentOption == 2) {
            txt = 'Consignment'
        }
        else if (this.props.InvoiceCust.paymentOption == 3) {
            txt = 'Net Terms'
        }
        else {
            txt = (this.props.InvoiceCust.paymentOption)
        }
        var Balance = parseFloat(this.props.stotal) - parseFloat(this.props.scredit) - parseFloat(this.props.spayment);
        var ival = 0;
        var duplicateitemlist = '';
        return (
            <div className="thd-content-body thd-content-body-invoice bg-white">
                <table width="100%">
                    <tr>
                        <td align="center" className="text-center">

                            <Button variant="outline-secondary" onClick={() => { this.print() }}>
                                Print
                            </Button>
                        </td>
                    </tr>
                </table>
                <Card className="border-0 rounded-0 card-invoice" id="printarea">

                    <Card.Body>
                        <table cellPadding="5" cellSpacing="0" border="0" width="100%">
                            <tr>
                                <td>
                                    <div className="border-right thd-logo">
                                        <img src={'img/thd-logo.png'} alt="THD Logo" />
                                    </div>
                                </td>
                                <td>
                                    <div className="billed-from">
                                        <div className="invoice-content">

                                            <h3 className="mb-2">{this.props.InvoiceCust.firstName}{this.props.InvoiceCust.lastName}</h3>
                                            <p>
                                                {this.props.InvoiceCust.address1},
                                        {this.props.InvoiceCust.address2},
                                        {this.props.InvoiceCust.city},
                                        {this.props.InvoiceCust.country}
                                                <br />
                                                Tel No: {this.props.InvoiceCust.phoneNumber1} <br />
                                                Email:  {this.props.InvoiceCust.email}
                                            </p>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div className="invoice-header mb-5">
                                        <h1 className="invoice-title">Invoice</h1>
                                    </div>
                                </td>
                            </tr>
                        </table>
                        <table cellPadding="5" cellSpacing="0" border="0" width="100%">
                            <tr>
                                <td width="33%">
                                    <table width="100%">
                                        <tr>
                                            <td colSpan="">
                                                <span className="">Client</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <span className="">{this.props.InvoiceCust.company}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <span className="">C/o {this.props.InvoiceCust.firstName}{this.props.InvoiceCust.lastName}</span>
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                                <td width="25%"></td>
                                <td>
                                    <table width="100%">
                                        <tr>
                                            <td colSpan="2">
                                                <label className="tx-gray-600"><b>Invoice Information</b></label>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><span>Invoice No</span></td>
                                            <td align="right"><span className="text-right">{this.props.invoiceId}</span></td>
                                        </tr>
                                        <tr>
                                            <td style={{ borderTop: "1px dotted #9fa5ad" }}><span>Amount Due</span></td>
                                            <td style={{ borderTop: "1px dotted #9fa5ad" }} align="right"><span className="text-right">{Balance.toFixed(2) ? numberformat(Balance.toFixed(2)) : Balance.toFixed(2)}</span></td>
                                        </tr>
                                        <tr>
                                            <td style={{ borderTop: "1px dotted #9fa5ad" }}><span>Issue Date:</span></td>
                                            <td style={{ borderTop: "1px dotted #9fa5ad" }} align="right"><span className="text-right"><Moment format="MM/DD/YYYY">{this.props.Data.invoiceDate}</Moment></span></td>
                                        </tr>
                                        <tr>
                                            <td style={{ borderTop: "1px dotted #9fa5ad" }}><span>Terms:</span></td>
                                            <td style={{ borderTop: "1px dotted #9fa5ad" }} align="right"><span className="text-right">{txt}</span></td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                        </table>
                        <div className="mt-5">


                            <Table cellPadding="5" border="1" cellSpacing="0" width="100%" align="center" responsive size="xl" className="table-invoice">
                                <thead>
                                    <tr>
                                        <th colSpan="6" className="text-center datacol">Invoiced Items</th>
                                    </tr>
                                    <tr>
                                        <th className="text-center">Order #</th>
                                        <th className="text-center" >Description</th>
                                        <th className="text-center">Unit Cost</th>
                                        <th className="text-center">Qty</th>
                                        <th className="text-center">Rate</th>
                                        <th className="text-center" >Price</th>
                                    </tr>
                                </thead>
                                <tbody className="pheonixes discription">
                                    {this.props.InvoiceList != null ? this.props.InvoiceList.map(invoiceItemList => {
                                        if (!invoiceItemList.isCredit && !invoiceItemList.isPayment) {
                                            //if ((ival > 0)) {
                                            //    if (duplicateitemlist != invoiceItemList.truckload_barcode) {
                                            //        ival = 0;
                                            //    }
                                            //}

                                            //if (ival == 0) {
                                            //    duplicateitemlist = invoiceItemList.truckload_barcode;
                                            //}
                                            //if (ival == 0) {
                                            //       ival++;
                                                if (invoiceItemList.truckLoadOrderamount == 0) {
                                                    var quant = (invoiceItemList.quantity / 100).toFixed(4);
                                                    console.log("Inside if condition");
                                                    console.log(quant);

                                                    return (

                                                        <tr key={invoiceItemList.id}>
                                                            <td onClick={() => this.handleShow(invoiceItemList.item.split(':')[1].split(' ')[1])}>{invoiceItemList.item.split(':')[0]}<span style={{ cursor: 'pointer', color: 'blue' }}> {invoiceItemList.item.split(':')[1]}</span></td>
                                                            <td className="text-left"><b>{/*{invoiceItemList.truckload_barcode}*/}</b> {invoiceItemList.description}</td>

                                                            <td className="text-right">{invoiceItemList.unitCost ? numberformat(invoiceItemList.unitCost) : invoiceItemList.unitCost}</td>
                                                            <td className="text-center">{invoiceItemList.containerQuantity}</td>
                                                            <td className="text-right">{quant}</td>
                                                            <td className="text-right">{(invoiceItemList.unitCost * quant).toFixed(2) ? numberformat((invoiceItemList.unitCost * quant).toFixed(2)) : (invoiceItemList.unitCost * quant).toFixed(2)}</td>
                                                        </tr>

                                                    )
                                                }
                                                else {
                                                    var unitcosttotal = invoiceItemList.unitCost;
                                                    var quant = (invoiceItemList.new_BuyitNow_Rate / 100).toFixed(4);;
                                                    console.log("Inside else condition");
                                                    console.log(quant);
                                                    return (


                                                        <tr key={invoiceItemList.id}>
                                                            <td onClick={() => this.handleShow(invoiceItemList.item.split(':')[1].split(' ')[1])}>{invoiceItemList.item.split(':')[0]}<span style={{ cursor: 'pointer', color: 'blue' }}> {invoiceItemList.item.split(':')[1]}</span></td>
                                                            <td className="text-left"> <b>{/*{invoiceItemList.truckload_barcode}*/}</b> {invoiceItemList.description}</td>

                                                            <td className="text-right">{unitcosttotal ? numberformat(unitcosttotal) : unitcosttotal}</td>
                                                            <td className="text-center">{invoiceItemList.containerQuantity}</td>
                                                            <td className="text-right">{quant}</td>
                                                            <td className="text-right">{(unitcosttotal * quant).toFixed(2) ? numberformat((unitcosttotal * quant).toFixed(2)) : (unitcosttotal * quant).toFixed(2)}</td>
                                                        </tr>

                                                    )
                                                }
                                             
                                           /* }*/
                                          
                                        }

                                    }): null}
                                </tbody>
                                <tbody>
                                    <tr>
                                        <th colSpan="6" className="text-center datacol">Credits</th>
                                    </tr>
                                    <tr>
                                        <th className="text-left">Order #</th>
                                        <th className="text-left">Description</th>
                                        <th className="text-left">Credit Reason</th>
                                        <th className="text-left">Credit Issue Date</th>
                                        <th colSpan="2" className="text-left">Credit Total</th>
                                    </tr>
                                </tbody>

                                <tbody className="pheonixes">
                                    {this.props.InvoiceListTruck != null ? this.props.InvoiceListTruck.map(invoiceItemList => {
                                        if (invoiceItemList.isCredit) {
                                            return (

                                                <tr>
                                                    <td onClick={() => this.handleShow(invoiceItemList.item.split(':')[0])}><span style={{ cursor: 'pointer', color: 'blue' }}> {invoiceItemList.item.split(':')[0]}</span></td>
                                                    <td className="text-left">{invoiceItemList.description}</td>
                                                    <td className="text-right">{invoiceItemList.creditReason}</td>
                                                    <td className="text-right">{invoiceItemList.paymentDate}</td>
                                                    <td colSpan="2" className="text-right">{(invoiceItemList.unitCost * invoiceItemList.quantity).toFixed(2) ? numberformat((invoiceItemList.unitCost * invoiceItemList.quantity).toFixed(2)) : (invoiceItemList.unitCost * invoiceItemList.quantity).toFixed(2)}</td>
                                                </tr>

                                            )
                                        }
                                    }) : null}
                                </tbody>
                                <tbody>

                                    <tr>
                                        <th colSpan="6" className="text-center datacol">Payments Applied</th>
                                    </tr>
                                    <tr>
                                        <th colSpan="2" className="text-center">Payment Date</th>

                                        <th colSpan="4" className="text-center" >Payment Amount</th>
                                    </tr>
                                </tbody>

                                <tbody className="pheonixes">
                                    {this.props.InvoiceListTruck != null ? this.props.InvoiceListTruck.map(invoiceItemList => {
                                        if (invoiceItemList.isPayment) {
                                            return (

                                                <tr key={invoiceItemList.id}>
                                                    <td colSpan="2" className="text-center">{invoiceItemList.paymentDate}</td>

                                                    <td colSpan="4" className="text-center" >{invoiceItemList.paymentAmount ? numberformat(invoiceItemList.paymentAmount) : invoiceItemList.paymentAmount}</td>
                                                </tr>

                                            )
                                        }
                                    }) : null}

                                </tbody>
                                <tbody>
                                    <tr>
                                        <th colSpan="6" className="text-center datacol" >Summary</th>
                                    </tr>
                                    <tr className="data">
                                        <td colSpan="3" className="blank">
                                            PLEASE ACH OR WIRE PAYMENT TO THE HOME DEPOT:
                                            </td>
                                        <td colSpan="1" className="total-line">Total Invoiced</td>
                                        {//<td colSpan="1"><div id="totalqty"></div></td-->
                                        }
                                        <td colSpan="2" className="total-value"><div id="subtotal">{this.props.stotal ? numberformat(this.props.stotal) : this.props.stotal}</div></td>
                                    </tr>
                                    <tr className="data">
                                        <td colSpan="3" className="blank">
                                            Bank: Citibank, 111 Wall Street, New York, NY 10005
                    </td>
                                        <td colSpan="1" className="credit-line">Credits</td>

                                        <td colSpan="2" className="total-value"><div id="totalcredits">{this.props.scredit ? numberformat(this.props.scredit) : this.props.scredit}</div></td>
                                    </tr>
                                    <tr className="data">
                                        <td colSpan="3" className="blank">
                                            Account Name: HOME DEPOTS USA INC. BRANDS DIRECT<br />
                                            Account Holder Address: 2455 Paces Ferry Rd SE, Atlanta, GA 30339
                                             </td>
                                        <td colSpan="1" className="total-line">Payments Applied</td>

                                        <td colSpan="2" className="total-value"><div id="totalpayments">{this.props.spayment ? numberformat(this.props.spayment) : this.props.spayment}</div></td>
                                    </tr>
                                    <tr className="data">
                                        <td colSpan="3" className="blank fill" >
                                            Routing (ABA) #: 031100209 / Account #: 38741154<br /><br />
                                            Instructions: Please include Invoice/s in comments or reference field upon payment
                                              </td>
                                        <td colSpan="1" className="total-line balance">Balance Due</td>

                                        <td colSpan="2" className="total-value balance"><div className="due">{Balance.toFixed(2) ? numberformat(Balance.toFixed(2)) : Balance.toFixed(2)}</div></td>
                                    </tr>
                                </tbody>

                            </Table>


                        </div>
                        <iframe id="ifmcontentstoprint" style={{
                            height: '0px',
                            width: '0px',
                            position: 'absolute'
                        }}></iframe>

                        <hr className="mg-b-40" />
                        <div className="Thanku_Message mt-5">
                            <h6 className="mb-4">Please pay within {this.props.InvoiceCust.netTermDays} days. Thank you for your business.</h6>
                            <h5 className="mb-2">TERMS AND CONDITIONS</h5>
                            <div className="footer-invoice">
                                <img src={'img/thd-logo.png'} alt="THD Logo" className="float-left mr-3" />
                                <p className="float-left"> Payment Terms.  All pricing and payments are and shall be in U.S. dollars. Purchaser shall make all payments for the Salvage Goods immediately to Home Depot by electronic funds transfer or with Home Depot’s preapproval, by bank certified check. No cash transactions are accepted. NOTICE: Once you have submitted the wire payment please email salvage@homedepot.com so we can ensure your payment has been applied to the account accordingly.
                <br /><br />
                                        Disclaimer of Warranties. PURCHASER ACKNOWLEDGES AND AGREES THAT ALL SALVAGE GOODS ARE PURCHASED "AS IS," WITH NO WARRANTY OF ANY NATURE OR TYPE WHATSOEVER AND HEREBY DISCLAIMS ALL EXPRESS, IMPLIED, AND STATUTORY WARRANTIES, INCLUDING WITHOUT LIMITATION THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT, EXCEPT WARRANTY OF TITLE.
                <br /><br />
                                        Taxes. Purchaser is responsible for all taxes, tariffs, duties and applicable expenses based on any sales transactions occurring under this Agreement. Sales taxes will be added to the purchase price unless a copy of Purchaser's sales tax exemption agreement is received by Home Depot prior to purchase.
                <br /><br />
                                        Title and Risk of Loss. Title and risk of loss shall pass to Purchaser at the applicable Home Depot Repair and Liquidation Center. Purchaser is solely responsible for arranging for shipping and transportation and any further sale of all Salvage Goods, including, without limitation, shipping document preparation, proper packaging and labeling, and compliance with all laws, rules and regulations related thereto, including, without limitation, those relating to exporting  Any claims for shortage of Salvage Goods shipped must be received by Home Depot no more than (10) calendar days following the date of shipment. Home Depot shall have no responsibilities or liability for any such claims received after such ten (10) day period. Any claim for shortage of Salvage Goods must be received by Home Depot in writing within ten (10) calendar days of the date of shipment.
                <br /><br />
                                </p>







                            </div>
                        </div>


                    </Card.Body>
                </Card>
                <table width="100%">
                    <tr>
                        <td align="center" className="text-center">

                            <Button variant="outline-secondary" onClick={() => { this.print() }}>
                                Print
                            </Button>
                        </td>
                    </tr>
                </table>
                <Modal centered size="xl" show={this.state.show} onHide={this.handleClose} className="sb-details-modal">
                    <Modal.Header closeButton>
                        <Modal.Title>Order Details</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <OrderDetail orderNumber={this.state.orderNumber} />
                    </Modal.Body>
                </Modal>
            </div>


        )
    }
}
export default InvoiceDetailSalvageSalesTruck;